const es = {
  common: {
    loading: 'Cargando...',
    error: 'Error',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    moveUp: 'Subir',
    moveDown: 'Bajar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    yes: 'Sí',
    no: 'No',
    back: 'Atrás',
    next: 'Siguiente',
    submit: 'Enviar',
    darkMode: 'Modo oscuro',
    lightMode: 'Modo claro',
    languageMenuTitle: 'Cambiar idioma',
    pagerShow: 'Mostrar',
    pagerPerPage: 'por página',
    pagerOf: 'de',
    viewCards: 'Vista tarjetas',
    viewList: 'Vista lista',
    collapse: 'Colapsar',
    expand: 'Expandir',
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
    retry: 'Reintentar',
    errorBoundaryTitle: 'Algo salió mal',
    errorGeneric: 'Ocurrió un error inesperado. Por favor intenta de nuevo.',
    expandModal: 'Expandir en modal',
    resetToGlobal: 'Restablecer a global',
    appName: 'Sigma Pulse',
  },
  nav: {
    home: 'Home',
    growth: 'Crecimiento',
    admin: 'Administración',
    executive: 'Ejecutivo',
    analytics: 'Analytics',
    switchDemoProfile: 'Cambiar perfil de demo',
    mobileNav: 'Navegación principal',
  },
  roles: {
    employee: 'Empleado',
    adminOU: 'Admin OU',
    adminGlobal: 'Admin Global',
  },
  platform: {
    teams: 'TEAMS',
  },
  survey: {
    title: 'Encuestas pendientes',
    pending: 'Pendiente',
    completed: 'Completada',
    expired: 'Expirada',
    submit: 'Enviar evaluación',
    skip: 'Omitir',
    noObs: 'Sin observación',
    meeting: 'Reunión',
    duration: 'Duración',
    participants: 'Participantes',
    simulateMeeting: 'Simular fin de junta',
    thankYou: '¡Gracias por tu evaluación!',
    evaluating: 'Evaluando a',
    of: 'de',
    question: 'Pregunta',
    selectResponse: 'Selecciona una respuesta',
    nps: {
      question: '¿Qué tan probable es que recomiendas trabajar con esta persona?',
      detractor: 'Detractor',
      passive: 'Pasivo',
      promoter: 'Promotor',
    },
    evaluateNow: 'Evaluar ahora',
    postpone: 'Después',
    expires: 'Expira',
    noSurveysPending: '¡Sin encuestas pendientes! Buen trabajo.',
    weekCompleted: 'sem.',
    likert: {
      always: 'Siempre',
      usually: 'Casi siempre',
      sometimes: 'A veces',
      rarely: 'Casi nunca',
      notObservable: 'No observable',
    },
    questions: {
      listenedActivelyText: '¿Esta persona escuchó activamente y mostró interés genuino?',
      sharedKnowledgeText: '¿Compartió conocimiento o experiencias relevantes durante la sesión?',
    },
    completeSubtitle: 'Tu retroalimentación ayuda a fortalecer la cultura del equipo.',
    backToHome: 'Volver al inicio',
    // Home page
    greetingMorning: 'Buenos días',
    greetingAfternoon: 'Buenas tardes',
    greetingEvening: 'Buenas noches',
    pendingCountPre: 'Tienes',
    pendingCountSingular: 'encuesta pendiente',
    pendingCountPlural: 'encuestas pendientes',
    allDoneTitle: '¡Todo al día!',
    allDoneSubtitle: 'No tienes encuestas pendientes. Después de tu próxima junta aparecerán aquí.',
    omit: 'Omitir',
    omitSurvey: 'Omitir encuesta',
    submitSuccess: 'Respuestas enviadas',
    submitError: 'Error al enviar — intenta de nuevo',
    omitSuccess: 'Encuesta omitida',
    omitError: 'Error al omitir — intenta de nuevo',
    kpi: {
      answered: 'Contestadas',
      omitted: 'Omitidas',
      streak: 'Racha',
      participation: 'Participación',
    },
    growth: {
      title: 'Tu crecimiento te espera',
      message: 'Revisa tus resultados, tendencias y áreas de desarrollo en tu panel de crecimiento.',
      cta: 'Ver mi crecimiento',
    },
    tips: {
      title: 'Tips para ti',
      based: 'Basados en tu score promedio',
      empty: 'Completa más encuestas para ver tips personalizados',
      reconocer: 'Para reconocer',
      crecer: 'Para crecer',
      tipOfDay: 'Tip del día',
    },
  },
  safe: {
    title: 'Mi Crecimiento',
    subtitle: 'Tu desarrollo cultural en Sigma',
    sectionName: 'Mi retroalimentación',
    surveysAnswered: 'Encuestas contestadas',
    score: 'Tu Score',
    evolution: 'Tu evolución',
    evolutionSub: 'Tu camino personal — solo tú, sin comparaciones',
    radarTitle: 'Tu perfil por Fundamental',
    radarSub: 'Tú hoy vs tú hace 3 meses — tu propio progreso',
    fundamentals: 'Fundamentales',
    fundamentalsChart: 'Tu retroalimentación por Fundamental',
    fundamentalsChartSub: 'Dónde estás en cada uno — click en cualquier barra para ver detalle',
    behaviors: 'Comportamientos',
    kudos: 'Reconocimientos',
    kudosTitle: 'Para Reconocer — lo que más aportas',
    kudosSub: 'Lo que tus compañeros observan más de ti este mes',
    actions: 'Plan de acción',
    omissions: 'Omisiones',
    period: 'Período',
    received: 'Recibidas',
    sent: 'Enviadas',
    areaAverage: 'Promedio área',
    today: 'Hoy (Ene 2026)',
    threeMonthsAgo: 'Hace 3 meses (Oct 2025)',
    detail: 'Detalle',
    profileTitle: 'Tu perfil cultural en palabras',
    profileSub: 'Comportamientos, no números',
    basedOn: 'Basado en {{count}} retroalimentaciones anónimas',
    level0: 'Inicio',
    level1: 'En desarrollo',
    level2: 'Consistente',
    level3: 'Referente',
    level0desc: 'Espera que otros resuelvan los problemas o eliminen los obstáculos.',
    level1desc: 'Intenta abordar los obstáculos, pero se rinde rápidamente o escala prematuramente.',
    level2desc: 'Toma la iniciativa para eliminar obstáculos y encontrar soluciones que impulsen el avance.',
    level3desc: 'Inspira a otros a tomar la iniciativa y crea un entorno donde desatascarse es una responsabilidad compartida.',
    levelAbbr0: 'Inicio',
    levelAbbr1: 'En des.',
    levelAbbr2: 'Consiste.',
    levelAbbr3: 'Referente',
    todayLabel: 'Hoy',
    pointsInMonths: 'puntos en {{n}} meses',
    monthsWithFeedback: 'meses con feedback',
    thisMonth: 'este mes',
    headingToLevel: 'Rumbo a {{level}}',
    maxLevel: '¡Nivel máximo!',
    narrativeStrength: 'Lo que más aportas y merece reconocimiento es <strong>{{fund}}</strong> — estás en nivel <strong>{{level}}</strong>.',
    narrativeConsistency: 'También muestras consistencia en {{others}}.',
    narrativeProgress: 'En los últimos 3 meses has avanzado — tu perfil muestra crecimiento.',
    narrativeStable: 'Tu perfil se ha mantenido estable en los últimos 3 meses — eso habla de consistencia.',
    narrativeVariation: 'Tu perfil ha variado un poco en los últimos meses. Las variaciones son normales y no definen tu trayectoria.',
    narrativeNextLevel: 'Tu siguiente nivel para crecer está en <strong>{{fund}}</strong>. El siguiente paso es llegar a nivel {{level}} — más abajo te sugerimos una acción concreta.',
    act01: 'Reconocimiento — cómo te ven',
    act02: 'Progreso — cómo has evolucionado',
    act03: 'Dirección — tu siguiente paso',
    reinforces: 'REFUERZA',
    tryToday: 'Lo intento hoy',
    committed: '¡Me comprometo hoy!',
    defaultChallenge: 'Practica un fundamental hoy',
    defaultChallengeDesc: 'Elige una micro-acción y ponla en práctica en tu próxima reunión.',
    clickDetail: 'Click para detalle',
    nextLevel: 'SIGUIENTE NIVEL',
    growthTitle: 'PARA SEGUIR CRECIENDO',
    growthSub: 'Recomendaciones basadas en tu retroalimentación',
    feedbacks: 'retroalimentaciones',
    peers: 'colegas',
    givenTitle: 'Mi participación dando retroalimentación',
    givenSub: 'Retroalimentaciones que has compartido este mes',
    footerPrivacy: 'Todo el feedback es anónimo. Nadie puede ver quién te lo dio. Esta vista es solo tuya.',
    footerHeart: 'Recuerda: el feedback es un regalo. Estos datos reflejan momentos en reuniones, no definen quién eres.',
    personSingular: 'persona',
    personsPlural: 'personas',
    trend: {
      up: 'Tu perfil muestra crecimiento',
      down: 'Pequeña variación — es normal',
      stable: 'Perfil estable — eso es consistencia',
    },
    empty: {
      title: 'Conoce los Fundamentals',
      desc: 'Aún no tienes suficiente retroalimentación para mostrar tu dashboard. Mientras tanto, explora los comportamientos que medimos.',
      hint: 'Necesitas al menos 3 evaluaciones para activar tu dashboard personal. Participa en las encuestas post-reunión para empezar a recibir feedback.',
    },
    popup: {
      peersOpined: 'colegas opinaron',
      subbehaviors: 'Sub-comportamientos',
      monthlyHistory: 'Evolución mensual',
      distribution: 'Distribución de retroalimentaciones',
      behaviorScale: 'Escala de comportamiento',
      you: 'Tú',
    },
  },
  admin: {
    title: 'Administración',
    // Sidebar
    panelTitle: 'Panel Admin',
    roleAdminCentral: 'Admin Central',
    roleAdminOU: 'Admin OU',
    roleEmployee: 'Empleado',
    greetingMorning: 'Buenos días',
    greetingAfternoon: 'Buenas tardes',
    greetingEvening: 'Buenas noches',
    // Main tabs
    surveys: 'Encuestas',
    templates: 'Templates',
    analyticsTab: 'Analytics',
    rulesTab: 'Reglas de Negocio',
    users: 'Usuarios',
    notifications: 'Notificaciones',
    // Surveys tab
    surveysTitle: 'Gestión de Encuestas',
    searchSurvey: 'Buscar encuesta...',
    trash: 'Papelera',
    newSurvey: 'Nueva Encuesta',
    fundamentalsTab: 'Generales',
    customTab: 'Personalizadas',
    colName: 'Nombre',
    colTitle: 'Título',
    colDescription: 'Descripción',
    colQuestions: 'Preguntas',
    colStatus: 'Estado',
    colAudience: 'Audiencia',
    colFrequency: 'Frecuencia',
    colFeedback: 'Retroalimentaciones',
    colPeriod: 'Periodo',
    colActions: 'Acciones',
    colCreatedBy: 'Creada por',
    colEmail: 'Email',
    colOU: 'OU',
    colUses: 'usos',
    statusActive: 'Activa',
    statusPaused: 'Pausada',
    statusInactive: 'Inactiva',
    statusPending: 'Pendiente',
    anonymous: 'Anónima',
    duplicate: 'Duplicar',
    exportExcelTip: 'Exportar Excel',
    // Templates tab
    templatesTitle: 'Templates de Encuestas',
    tipsTab: 'Tips',
    actionsTab: 'Acciones',
    catalogTab: 'Catálogos',
    createTemplate: 'Crear template',
    typeFundamental: 'Fundamental',
    typeCustom: 'Personalizada',
    placeholderTips: 'Tips — Módulo de consejos para colaboradores',
    placeholderActions: 'Acciones — Planes de acción post-encuesta',
    placeholderCatalog: 'Catálogo de Fundamentales — Biblioteca de comportamientos evaluables',
    // Templates catalog controls
    tplSearchPlaceholder: 'Buscar template…',
    tplFilterAll: 'Todos los tipos',
    tplNoResults: 'No hay templates con ese criterio',
    // Tips sub-tab
    tipsTitle: 'Tips de Feedback',
    tipsSearchPlaceholder: 'Buscar tip…',
    tipsAllFundamentals: 'Todos los Fundamentales',
    tipsAllTypes: 'Todos los tipos',
    tipTypeReconocer: 'Para Reconocer',
    tipTypeCrecer: 'Para Crecer',
    tipsNoResults: 'No hay tips con ese criterio',
    surveysNoResults: 'No hay encuestas con ese criterio',
    surveysError: 'Error al obtener las encuestas. Intente más tarde.',
    createTip: 'Crear tip',
    // Acciones sub-tab
    actionsTitle: 'Acciones de Crecimiento',
    actionsSearchPlaceholder: 'Buscar acción…',
    actionsNoResults: 'No hay acciones con ese criterio',
    createAction: 'Crear acción',
    // Catálogo sub-tab
    catalogTitle: 'Catálogo de Fundamentales',
    catalogFundamentals: 'Fundamentales',
    catalogBehaviors: 'Behaviors',
    catalogAddFundamental: 'Agregar Fundamental',
    catalogAddBehavior: 'Agregar Daily Habit',
    catalogSearchFundamental: 'Buscar fundamental…',
    catalogSearchBehavior: 'Buscar daily habit…',
    catalogNoBehaviors: 'Sin daily habits para este fundamental',
    catalogSelectFundamental: 'Selecciona un Fundamental de la lista',
    // OUs sub-tab
    ousTab: 'OUs',
    ousTitle: 'Unidades Organizativas',
    ousSubtitle: 'Gestiona las OUs raíz del tenant',
    ousSearchPlaceholder: 'Buscar OU…',
    ousNoResults: 'No hay OUs con ese criterio',
    createOU: 'Crear OU',
    editOU: 'Editar OU',
    deleteOU: 'Eliminar OU',
    deleteOUConfirm: '¿Eliminar la OU "{{name}}"? Esta acción no se puede deshacer.',
    ouDescription: 'Descripción',
    ouAdminUser: 'Admin OU (AAD User ID)',
    ouType: 'Tipo',
    ouGdpr: 'GDPR',
    ouAzureGroupId: 'ID de grupo de Azure AD',
    ouAzureGroupIdHint: 'Vincula esta OU con su grupo real en Azure AD para el árbol jerárquico. Déjalo vacío si aún no está provisionado.',
    ouAzureGroupIdSelectPlaceholder: '— Selecciona un grupo raíz de Azure AD —',
    ouAzureGroupIdLoading: 'Cargando grupos de Azure AD…',
    ouAzureGroupIdRootsError: 'No se pudo cargar la lista de grupos de Azure AD. Puedes escribir el ID manualmente.',
    ouAzureGroupIdCurrentUnknown: 'Grupo vinculado actual (no aparece en la lista)',
    ouAzureGroupIdManualToggle: 'Escribir el ID manualmente',
    ouAzureGroupIdListToggle: 'Elegir de la lista',
    ouActivate: 'Activar OU',
    ouDeactivate: 'Desactivar OU',
    ouExpand: 'Expandir',
    ouCollapse: 'Colapsar',
    ouSelectPlaceholder: 'Seleccionar OU…',
    ouErrorName: 'El nombre de la OU es obligatorio',
    ouTimezone: 'Zona Horaria',
    ouTimezoneSelect: 'Selecciona zona horaria',
    ouErrorTimezone: 'La zona horaria es obligatoria',
    // Table columns
    colFundamental: 'Fundamental',
    colCondition: 'Condición',
    placeholderAnalytics: 'Dashboard unificado de Analytics — Ver vista Ejecutivo para detalle completo',
    // Analytics KPIs
    activeUsersLabel: 'Colaboradores activos',
    avgCulturalScore: 'Score cultural promedio',
    participationRateLabel: 'Tasa de participación',
    omissionRateLabel: 'Tasa de omisión',
    thisMonth: 'este mes',
    // Rules tab
    rulesTitle: 'Reglas de Negocio',
    restoreDefaults: 'Restaurar Defaults',
    restoreDefaultsTitle: 'Restaurar configuración por defecto',
    restoreDefaultsDesc: 'Se restablecerán todos los valores de las reglas de negocio a su configuración original. Esta acción no se puede deshacer.',
    restoreDefaultsConfirm: 'Sí, restaurar',
    rn001Title: 'Criterios de Reunión',
    rn001Subtitle: 'Define la duración de reuniones que activan encuesta',
    rn002Title: 'Reglas de Exclusión',
    rn002Subtitle: 'Escenarios donde NO se detonan encuestas',
    rn004Title: 'Límites por Usuario',
    rn004Subtitle: 'Controla la cantidad de encuestas que recibe cada persona',
    rn005Title: 'Límite Diario de Encuestas',
    rn005Subtitle: 'Número máximo de encuestas que un usuario puede recibir por día',
    fieldMinSessionDuration: 'Duración mínima de sesión',
    fieldMaxSessionDuration: 'Duración máxima de sesión',
    fieldMinParticipants: 'Mínimo de participantes',
    fieldMaxParticipants: 'Máximo de participantes',
    fieldExclRecurring: 'Excluir reuniones recurrentes',
    fieldExclRecurringSub: 'No aplicar en juntas semanales, dailies, etc.',
    fieldExclWorkHours: 'Excluir fuera de horario laboral',
    fieldExclWorkHoursSub: 'Solo aplicar dentro del horario configurado por OU',
    fieldMaxSurveysWeek: 'Máximo de encuestas por semana',
    fieldMaxParticipantsPerSurvey: 'Máximo de participantes a evaluar por encuesta',
    fieldMinInterval: 'Intervalo mínimo entre encuestas',
    fieldMaxSurveysDay: 'Máximo de encuestas por día por usuario',
    rn005Info: 'Si un usuario ya recibió el máximo de encuestas en el día, las siguientes se posponen al día hábil siguiente respetando el orden de prioridad configurado.',
    suffixMinutes: 'minutos',
    suffixUsers: 'usuarios',
    suffixSurveysWeek: 'encuestas/semana',
    suffixPersons: 'personas',
    suffixHours: 'horas',
    suffixSurveysDay: 'encuestas / día',
    customizableByOU: 'Personalizable por OU',
    cancelChanges: 'Cancelar cambios',
    saveConfig: 'Guardar configuración',
    rulesConfig: 'Configuración',
    rulesStatus: 'Estado',
    rulesCustom: 'Personalizado',
    rulesSave: 'Guardar',
    rulesCancel: 'Cancelar',
    rulesSchedule: 'Horario',
    rulesInheritsGlobal: '↑ Hereda global',
    rulesInherited: 'Heredado',
    rulesGlobal: 'Global',
    rulesPersonalize: 'Personalizar',
    tplCatAll: 'Todos',
    tplCatGeneral: 'General',
    tplCatCustom: 'Personalizada',
    // Users tab
    usersTitle: 'Gestión de Usuarios',
    searchUser: 'Buscar usuario...',
    newUser: 'Nuevo usuario',
    // Notifications tab
    notificationsTitle: 'Configuración de Notificaciones',
    notifOmitirTitle: 'Notificación de "OMITIR"',
    notifyAfter: 'Notificar después de',
    consecutiveOmissions: '"OMITIR" consecutivos',
    notifyTo: 'Notificar a:',
    notifyUser: 'Usuario',
    notifyDirectManager: 'Manager directo',
    notifyAdminOU: 'Administrador OU',
    messageForUser: 'Mensaje para el usuario:',
    availableVarsOmitir: 'Variables disponibles: {nombre}, {count}, {fecha}, {manager}',
    europaOmissionsTitle: 'Omisiones Europa (BU)',
    manualOnlyGDPR: 'Solo manual — GDPR',
    gdprWarning: 'Por regulaciones legales (GDPR), los correos de omisión para Europa nunca se envían automáticamente. El administrador debe redactarlos, revisarlos y enviarlos manualmente.',
    emailTemplateEmployee: 'Plantilla de correo — empleado Europa:',
    reviewBeforeSending: 'Revisar y personalizar antes de cada envío.',
    generalNotificationsTitle: 'Notificaciones Generales',
    notifMessageLabel: 'Mensaje de la notificación:',
    notifMessagePlaceholder: 'Escribe el mensaje que deseas enviar a los colaboradores...',
    notifAudienceLabel: 'Audiencia:',
    notifAudienceGlobal: 'Global (excl. Europa)',
    sendNotification: 'Enviar notificación',
    availableVarsGeneral: 'Variables disponibles: {nombre}, {ou}, {fecha}',
    saveChanges: 'Guardar cambios',
    saveTemplates: 'Guardar plantillas',
    // Sidebar collapse/expand
    sidebarExpand: 'Expandir menú',
    sidebarCollapse: 'Colapsar menú',
    // Analytics placeholder
    analyticsComingSoon: 'Dashboard de Analytics — en desarrollo. Ver vista Ejecutivo para detalle completo.',
    // Table column: type
    colType: 'Tipo',
    // Templates catalog
    tplCategory: 'Categoría',
    tplQuestions: 'preguntas',
    tplUse: 'Usar',
    tplDeleteTitle: 'Eliminar template',
    tplDeleteDesc: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    tipDeleteTitle: 'Eliminar tip',
    tipDeleteDesc: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    // Tips form
    tipEditTitle: 'Editar tip',
    tipAddTitle: 'Agregar tip',
    tipFormFundamental: 'Fundamental',
    tipFormSelectFundamental: 'Selecciona un fundamental…',
    tipFormDailyHabit: 'Daily Habit vinculado',
    tipFormSelectDailyHabit: 'Selecciona un Daily Habit…',
    tipFormOperator: 'Operador',
    tipFormThreshold: 'Umbral %',
    tipFormMax: 'Máx %',
    tipFormType: 'Tipo de tip',
    tipFormName: 'Nombre del tip',
    tipFormNamePlaceholder: 'Ej. Aprendizaje Sobresaliente',
    tipFormText: 'Texto del tip',
    tipFormTextPlaceholder: 'Mensaje que verá el colaborador…',
    tipFormActivationRule: 'Condición de resultado',
    tipFormActive: 'Activo',
    tipFormPreview: 'Vista previa',
    tipRangeMin: 'Límite mínimo',
    tipRangeMax: 'Límite máximo',
    tipHintCondition: 'Score promedio del fundamental (0–100). Ej: de 0 a 40 activa el tip en resultados bajos.',
    tipHintBehavior: 'Comportamiento específico al que aplica este tip.',
    tipFieldObserved: 'Texto observado',
    tipTagGreen: 'caja verde clara',
    tipTagDark: 'caja oscura',
    tipTagBlue: 'recuadro Siguiente Nivel',
    tipHintObserved: 'Lo que los compañeros observan. Aparece en cursiva en panel de logros.',
    tipFieldGrowthSuggestion: 'Sugerencia Para Crecer',
    tipHintGrowthSuggestion: 'Sugerencia accionable que aparece junto al reconocimiento.',
    tipFieldLevelName: 'Nombre del nivel',
    tipLevelNamePlaceholder: 'Ej. Impulso Necesario, En Construcción…',
    tipCrecerPairedPlaceholder: 'Ej. Menciona al consumidor: En tu próxima decisión, pregunta…',
    tipTranslations: 'Traducciones',
    tipAddLang: '+ Agregar:',
    tipPreviewContext: 'Así se verá en el dashboard del colaborador:',
    tipSave: 'Guardar tip',
    tipSaveError: 'Para guardar, completa los siguientes campos:',
    colContent: 'Contenido',
    colActive: 'Activo',
    // Operators
    opGte: 'mayor o igual',
    opLte: 'menor o igual',
    opGt: 'mayor que',
    opLt: 'menor que',
    opBetween: 'Entre (rango)',
    // Actions form
    actionEditTitle: 'Editar acción',
    actionNewTitle: 'Nueva acción',
    actionFormTitle: 'Título de la acción',
    actionFormTitlePlaceholder: 'Ej. Propón una acción concreta',
    actionFormDescription: 'Descripción completa',
    actionFormDescPlaceholder: 'Descripción de la acción…',
    actionActivationRule: 'Regla de activación',
    actionActivationRuleHint: 'Score promedio del fundamental (1–4). Define el rango que activa esta acción.',
    actionRuleMin: 'Límite mínimo',
    actionRuleMax: 'Límite máximo',
    actionRangeLabel: 'Rango',
    actionNextLevelText: 'Texto "Siguiente Nivel"',
    actionNextLevelHint: 'Aparece en el recuadro azul de la tarjeta.',
    actionNextLevelPlaceholder: 'Ej. Para llegar al siguiente nivel, enfócate en…',
    actionPreview: 'Vista previa',
    actionPreviewEmpty: 'Completa el formulario para ver la vista previa',
    actionTranslations: 'Traducciones',
    actionTransComplete: 'Traducción completa',
    actionTransMissing: 'Traducción incompleta',
    actionPreviewContext: 'Así se verá en el dashboard del colaborador:',
    actionFormDescHint: 'Se muestra al abrir la acción.',
    actionSave: 'Guardar acción',
    actionSaveError: 'Para guardar, completa los siguientes campos:',
    actionDeleteTitle: 'Eliminar acción',
    actionDeleteDesc: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    // Fundamental form
    fundEditTitle: 'Editar Fundamental',
    fundNewTitle: 'Nuevo Fundamental',
    fundFormFullName: 'Nombre completo',
    fundFormFullNamePlaceholder: 'Ej. Mindset & Behavior - Learner',
    fundFormShortName: 'Nombre corto',
    fundFormShortNamePlaceholder: 'Ej. Learner',
    fundFormDescription: 'Descripción',
    fundFormDescriptionPlaceholder: 'Breve descripción de este fundamental...',
    fundFormIcon: 'Ícono',
    fundFormColor: 'Color',
    fundFormUrl: 'URL de referencia',
    fundFormUrlPlaceholder: 'https://...',
    imageUploadSelect: 'Subir imagen',
    imageUploadChange: 'Cambiar imagen',
    imageUploadInvalidFormat: 'Formato no soportado. Usa PNG, JPG, WEBP o SVG.',
    imageUploadTooLarge: 'El archivo excede el tamaño máximo permitido (2 MB).',
    fundFormLanguage: 'Idioma',
    fundFormAllLangsRequired: 'Completa el nombre completo, nombre corto y descripción en los 7 idiomas para poder guardar.',
    // Core Behavior form
    behEditTitle: 'Editar Daily Habit',
    behNewTitle: 'Nuevo Daily Habit',
    behFormName: 'Nombre del Daily Habit',
    behFormNamePlaceholder: 'Ej. Humility & Openness',
    behFormAllLangsRequired: 'Completa el nombre en los 7 idiomas para poder guardar.',
    behFormFundamental: 'Fundamental vinculado',
    behFormIntro: 'Intro / contexto de evaluación',
    behFormIntroPlaceholder: 'Ej. En esta junta, esta persona…',
    behFormRoles: 'Roles aplicables',
    behFormRolesHint: '¿a quién aplica este Daily Habit?',
    fundDeleteTitle: 'Eliminar fundamental',
    fundDeleteDesc: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    behDeleteTitle: 'Eliminar Daily Habit',
    behDeleteDesc: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    fundFormImage: 'Imagen',
    attNewTitle: 'Nueva Actitud y Comportamiento',
    attEditTitle: 'Editar Actitud y Comportamiento',
    attFormName: 'Nombre de la Actitud y Comportamiento',
    attFormNamePlaceholder: 'Ej. Colaboración activa',
    attFormDescription: 'Descripción de la Actitud y Comportamiento',
    attFormDescriptionPlaceholder: 'Breve descripción de esta actitud y comportamiento...',
    attFormAllLangsRequired: 'Completa el nombre en los 7 idiomas para guardar.',
    attFormImage: 'Imagen',
    attDeleteTitle: 'Eliminar Actitud y Comportamiento',
    attDeleteDesc: '¿Eliminar "{{name}}"? Sus Daily Habits también se desactivarán.',
    catalogAttitudesLabel: 'actitudes y comportamientos',
    catalogSelectAttitude: 'Selecciona una Actitud y Comportamiento de la lista',
    catalogBackToFundamentals: 'Volver a Fundamentales',
    catalogBackToAttitudes: 'Volver a Actitudes y Comportamientos',
    catalogGroupWithAttitudes: 'Agrupar en Actitudes y Comportamientos',
    // Catalog
    catalogNoFundamentals: 'Sin fundamentales',
    // Madurez Cultural editor
    madurezEditTitle: 'Editar niveles de Madurez Cultural',
    madurezFrameworkTitle: 'Madurez Cultural — Marco de niveles',
    nivelesAdopcionTitle: 'Etapas de adopción de un Daily Habit — Marco de niveles',
    nivelesAdopcionEditTitle: 'Editar etapas de adopción de un Daily Habit',
    madurezLabelPlaceholder: 'Etiqueta',
    // Notifications audiences
    audienceGlobal: 'Global (excl. Europa)',
    audienceMexico: 'México',
    audienceLATAM: 'LATAM',
    audienceUSA: 'USA',
    audienceFOSE: 'FOSE',
    // Rules tab — new keys
    rn000Title: 'Desactivar App por OU',
    rn000Subtitle: 'Apaga completamente Sigma Pulse para una o más unidades organizacionales. Los colaboradores de esas OUs no recibirán encuestas ni notificaciones.',
    rn000Warning: 'Al desactivar una OU, todos sus colaboradores dejan de recibir encuestas inmediatamente. Los datos históricos se conservan.',
    rn003Title: 'Horario Laboral por OU',
    rn003Subtitle: 'Horario en que se aplican encuestas (hora local)',
    rn003GlobalDefault: 'Horario global por defecto',
    rn003GlobalNote: 'Aplica a todas las OUs que no tengan un horario personalizado.',
    rn003TimeConnector: 'a',
    ouActive: 'Activa',
    ouDisabled: 'Desactivada',
    rn002KwLabel: 'Excluir solo si el nombre contiene:',
    rn002KwHint: '(vacío = todas las recurrentes)',
    rn002KwPlaceholder: 'Agregar palabra clave...',
    // Users tab — new keys
    usersAdminTitle: 'Gestión de Administradores',
    addAdmin: 'Agregar Administrador',
    editAdmin: 'Editar Administrador',
    newAdmin: 'Nuevo Administrador',
    adminEmail: 'Correo electrónico',
    adminEmailInvalid: 'Ingresa un correo electrónico válido (ej. nombre@dominio.com)',
    adminRole: 'Rol',
    adminRolePlaceholder: 'Selecciona un rol...',
    adminOU: 'Unidad Operativa (OU)',
    adminOUPlaceholder: 'Selecciona una OU...',
    adminOUAll: 'Todas (Acceso a todas las OUs)',
    adminBU: 'Unidad de Negocio (BU) — opcional',
    adminBUPlaceholder: 'Toda la OU (sin restricción)',
    adminBUHint: 'Si no seleccionas BU, el admin gestiona toda la OU.',
    colUser: 'Usuario',
    colAlcance: 'Alcance',
    colPermisos: 'Permisos',
    colEstado: 'Estado',
    permGlobalTitle: 'Admins OU/BU pueden crear encuestas',
    permGlobalDesc: 'Cuando está activo, todos los Admins OU/BU pueden crear y enviar encuestas (sujeto a aprobación del Admin Central).',
    permEnabled: 'Activado',
    permDisabled: 'Desactivado',
    permCreateSurveys: 'Crear encuestas',
    permViewAnalytics: 'Ver Analytics',
    permManageUsers: 'Gestionar Usuarios',
    permApproveSurveys: 'Aprobar encuestas',
    userDeleteTitle: 'Eliminar administrador',
    userDeleteDesc: '¿Eliminar a "{{name}}"? Esta acción no se puede deshacer.',
    noUsersFound: 'Sin resultados',
    adminCount: 'administradores',
    // Notifications tab — new keys
    messageForManager: 'Mensaje para el manager:',
    emailTemplateManager: 'Plantilla de correo — manager Europa:',
    notifOUPersonalization: 'Personalización por OU',
    addOUPersonalization: 'Agregar personalización',
    europaNoAutoSend: 'Estos correos no se envían automáticamente. Deben enviarse manualmente y estar alineados con el responsable de privacidad de Europa.',
    europaActivateTitle: '¿Activar notificaciones Europa?',
    europaActivateDesc: 'Las notificaciones de omisiones para Europa están sujetas a regulaciones GDPR estrictas. Al activar esta sección confirmas que cuentas con autorización del responsable de privacidad de la OU Europa y que los correos serán enviados manualmente con revisión previa.',
    europaActivateConfirm: 'Sí, activar con responsabilidad',
    includeEuropa: 'Incluir Europa (BU)',
    includeEuropaHint: 'requiere revisión GDPR antes de enviar',
    europaSectionDisabled: 'Sección desactivada — activa el switch para configurar',
    ouPersonalizedSingular: 'OU personalizada',
    ouPersonalizedPlural: 'OUs personalizadas',
    notifCustomUserMsgPlaceholder: 'Mensaje personalizado para el usuario…',
    notifCustomMgrMsgPlaceholder: 'Mensaje personalizado para el manager…',
    kwRemove: 'Quitar',
    kwAdd: 'Agregar',
    // Legacy keys kept for compatibility
    permissions: 'Permisos',
    rules: 'Reglas de negocio',
    catalog: 'Catálogo',
    createUser: 'Crear usuario',
    editUser: 'Editar usuario',
    deleteUser: 'Eliminar usuario',
    roles: 'Rol',
    organizationalUnit: 'Unidad Organizacional',
    minDuration: 'Duración mínima (min)',
    maxDuration: 'Duración máxima (min)',
    minParticipants: 'Participantes mínimos',
    maxPerDay: 'Máx. evaluaciones por día',
    maxPerWeek: 'Máx. evaluaciones por semana',
    omissionThreshold: 'Umbral de omisiones',
    columns: 'Columnas',
    colPickerTitle: 'Columnas visibles',
    colPickerReset: 'Restablecer',
    pagerRowsPerPage: 'Filas por página',
    pagerOf: 'de',
    confirmMoveToTrash: '¿Mover a papelera?',
    confirmMoveToTrashMsg: 'La encuesta se moverá a la papelera y se eliminará definitivamente en 30 días. Puedes restaurarla antes de ese plazo.',
    confirmMoveBtn: 'Mover a papelera',
    confirmDeleteForeverTitle: '¿Eliminar definitivamente?',
    confirmDeleteForeverMsg: 'Esta acción es irreversible. La encuesta y todos sus datos se borrarán para siempre.',
    confirmDeleteForeverBtn: 'Eliminar para siempre',
    trashTitle: 'Papelera de encuestas',
    trashSubtitle: 'Las encuestas se eliminan definitivamente después de 30 días',
    trashEmpty: 'La papelera está vacía',
    trashRestore: 'Restaurar',
    trashDaysLeft: 'días restantes',
    colSurvey: 'Encuesta',
    trashResponses: 'resp.',
    trashTimeLeft: 'Tiempo restante',
    trashDeletedBy: 'Eliminado por',
    trashDeletedAt: 'Fecha eliminación',
    trashDays: 'días',
    trashExpiresTODAY: 'Vence hoy',
    filterAll: 'Todos',
    filterSearchName: 'Buscar nombre…',
    filterSearchCreator: 'Buscar creador…',
    filterFrom: 'Desde',
    filterTo: 'Hasta',
    filterClearDates: 'Limpiar fechas',
    pauseSurvey: 'Pausar',
    activateSurvey: 'Activar',
    builderNewTitle: 'Nueva Encuesta',
    builderEditTitle: 'Editar Encuesta',
    builderNewTemplateTitle: 'Nuevo Template',
    builderEditTemplateTitle: 'Editar Template',
    builderBackToSurveys: 'Volver a encuestas',
    builderSaveDraft: 'Guardar borrador',
    builderPublish: 'Publicar encuesta',
    builderStep1: 'Información Básica',
    builderStep2: 'Audiencia y Frecuencia',
    builderStep3: 'Preguntas',
    builderStep4: 'Revisión',
    builderPreview: 'Vista Previa',
    builderName: 'Nombre de la encuesta',
    builderNamePlaceholder: 'Ej: Evaluación Post-Reunión Q2',
    builderDescription: 'Descripción',
    builderDescriptionPlaceholder: 'Describe el propósito de esta encuesta…',
    builderApproach: 'Enfoque',
    builderApproachIndividual: 'Individual',
    builderApproachCollective: 'Colectivo',
    builderAnonymous: 'Evaluación anónima',
    builderAnonymousSub: 'Los evaluados no sabrán quién los evaluó',
    dayMon: 'Lunes', dayTue: 'Martes', dayWed: 'Miércoles', dayThu: 'Jueves',
    dayFri: 'Viernes', daySat: 'Sábado', daySun: 'Domingo',
    dayMonShort: 'Lun', dayTueShort: 'Mar', dayWedShort: 'Mié', dayThuShort: 'Jue',
    dayFriShort: 'Vie', daySatShort: 'Sáb', daySunShort: 'Dom',
    dayLetterMon: 'L', dayLetterTue: 'M', dayLetterWed: 'X', dayLetterThu: 'J',
    dayLetterFri: 'V', dayLetterSat: 'S', dayLetterSun: 'D',
    activeDaysAll: 'La encuesta estará activa toda la semana',
    activeDaysPrefix: 'La encuesta estará activa de:',
    activeDaysNone: 'Ningún día seleccionado',
    workdays: 'Días laborales',
    builderExitTitle: '¿Salir del editor?',
    builderExitDesc: 'Los cambios no guardados se perderán si sales ahora.',
    builderExitCancel: 'Seguir editando',
    builderExitConfirm: 'Sí, salir',
    builderValidationTitle: 'Campos obligatorios',
    builderValidationDesc: 'Por favor completa los siguientes campos antes de continuar:',
    builderValidationClose: 'Entendido',
    builderValidationName: 'Identificador Interno',
    builderValidationSurveyType: 'Tipo de encuesta',
    builderValidationStartDate: 'Fecha de inicio',
    builderValidationEndDate: 'Fecha de fin',
    builderValidationDateRange: 'La fecha de fin no puede ser menor a la fecha de inicio',
    builderValidationActiveDays: 'Al menos un día de activación',
    builderValidationMeetingId: 'Captura el ID del Meeting',
    builderValidationPeople: 'Selecciona al menos una persona',
    builderValidationOU: 'Selecciona al menos una OU',
    builderValidationNoQuestions: 'Debes agregar al menos una pregunta para poder continuar. No se pueden generar encuestas sin preguntas.',
    builderValidationMinParticipants: 'El mínimo de participantes debe ser al menos 1',
    builderValidationMaxParticipants: 'El máximo de participantes debe ser al menos 1',
    builderValidationParticipantsRange: 'El mínimo de participantes no puede ser mayor al máximo',
    builderValidationTranslations: 'Traducciones incompletas',
    // Builder new keys
    builderCloseEditor: 'Cerrar editor',
    builderPrevious: 'Anterior',
    builderNext: 'Siguiente',
    builderSaveTemplate: 'Guardar como template',
    builderInternalId: 'Identificador interno',
    builderInternalIdHint: 'Solo visible para administradores — los empleados no ven este nombre al responder',
    builderSurveyTypeStar: 'Tipo de encuesta',
    builderTypeGeneral: 'General',
    builderTypeGeneralDesc: 'Se rige por reglas de negocio. Se dispara automáticamente tras reuniones.',
    builderTypePersonalized: 'Personalizada',
    builderTypePersonalizedDesc: 'Vinculada a una sesión específica de Teams por Meeting ID.',
    builderPeriod: 'Período de la encuesta',
    builderStartLabel: 'Inicio',
    builderEndLabel: 'Fin',
    builderPeriodHint: 'La encuesta se activará en la fecha de inicio y se desactivará automáticamente al finalizar',
    builderActiveDaysLabel: 'Días de activación',
    builderCustomTag: 'Personalizado',
    builderAudienceSectionTitle: 'Audiencia',
    builderWhoApplies: '¿A quién aplica esta encuesta?',
    builderSelectOneOrMoreOUs: 'Selecciona una o varias OUs',
    builderGlobal: 'Global',
    builderGlobalDesc: 'Todas las OUs y BUs',
    builderExcludesEurope: 'excluye Europa',
    builderGlobalAdminOUAccess: 'Administrador Global — tienes acceso a todas las OUs del sistema.',
    builderLegalRegulation: 'Regulación legal — siempre campo separado',
    builderEurope: 'Europa (BU)',
    builderGDPRTag: 'GDPR — Regulación legal',
    builderEuropeExcludedNote: 'Europa nunca está incluida en campañas Globales ni multi-OU por cumplimiento legal.',
    builderEuropaAuthNote: 'Recuerda contar con autorización de la OU Europa antes de enviar encuestas a esta región.',
    builderOUNotLinkedToAzureAD: 'Esta OU todavía no tiene subniveles disponibles — vincúlala con su grupo de Azure AD desde Administración › Unidades Organizacionales.',
    builderAudienceCustomTitle: 'Destinatarios',
    builderAudienceCustomSubtitle: 'Define quiénes recibirán esta encuesta personalizada.',
    builderRecipientsLabel: 'Destinatarios',
    builderByMeetingId: 'Por Meeting ID',
    builderByPeople: 'Personas específicas',
    builderByOU: 'Por organigrama (OU)',
    audienceTypeMeeting: 'Meeting',
    audienceTypePeople: 'Personas',
    audienceTypeOU: 'OU',
    builderMeetingIdHint: 'Se aplicará a todos los participantes de esa sesión de Teams',
    builderSelectPeople: 'Selecciona personas de la lista',
    builderAllOUs: 'Todas las OUs',
    builderAllAvailableAdded: 'Todos los disponibles ya fueron agregados',
    builderSearchPeoplePlaceholder: 'Buscar persona por nombre…',
    builderLoadingPeople: 'Cargando personas…',
    builderErrorLoadingPeople: 'No se pudo cargar la lista de personas. Intenta de nuevo.',
    builderPersonSelected: 'persona seleccionada',
    builderPeopleSelected: 'personas seleccionadas',
    builderSelectOU: 'Selecciona una OU...',
    builderSelectOUForTeam: 'Selecciona una OU para ver sus colaboradores',
    builderQuestionsTitle: 'Preguntas',
    builderEuropaQuestionsNote: 'Modo Europa: encuesta libre, sin vinculación a Fundamentales. Solo preguntas sobre la junta (reunión).',
    builderQuestionsApplyToAll: 'Cada pregunta se aplica a cada participante de la reunión.',
    builderFilterAll: 'Todos',
    builderNoQuestions: 'Aún no hay preguntas',
    builderNoQuestionsHint: 'Haz clic en "+ Agregar pregunta" para empezar',
    builderNoQuestionsOfType: 'Sin preguntas de este enfoque',
    builderAddQuestion: '+ Agregar pregunta',
    builderQuestionLabel: 'Pregunta',
    builderDeleteQuestion: 'Eliminar',
    builderApproachLabel: 'Enfoque',
    builderIndividualSub: 'Evalúa a cada participante',
    builderCollectiveSub: 'Para la sesión en general',
    builderPresentationMode: 'Modo de presentación',
    builderMatrix: 'Matriz General',
    builderMatrixSub: 'Pregunta sobre la junta o tema general',
    builderIndividualCard: 'Individual',
    builderIndividualCardSub: 'Una tarjeta por persona',
    builderTypeLabel: 'Tipo',
    builderFundamentalLabel: 'Fundamental',
    builderSelectFundamental: 'Selecciona un Fundamental...',
    builderDailyHabitLabel: 'Daily Habit',
    builderSelectDailyHabit: 'Selecciona un Daily Habit...',
    builderQuestionText: 'Texto de la pregunta',
    builderQuestionTextPlaceholder: 'Escribe la pregunta aquí',
    builderIconLabel: 'Ícono',
    builderOptional: '(opcional)',
    builderChangeIcon: 'Cambiar',
    builderSelectIconBtn: 'Seleccionar ícono',
    builderOptionsLabel: 'Opciones (máx. 4 + "No Observable")',
    builderNoObservable: 'No Observable',
    builderRemoveNoObs: 'Quitar No Observable',
    builderAddNoObs: 'Agregar "No Observable"',
    builderAddOption: 'Agregar Opción',
    builderMaxOptions: 'Máximo de 4 opciones alcanzado',
    builderNPSInfo: 'NPS: escala del 0 al 10. Pregunta libre, sin asignar a participantes.',
    builderOpenInfo: 'Espacio libre para que el evaluador escriba su respuesta.',
    builderCampaignWeight: 'Peso de campaña',
    builderAdminGlobalOnly: 'Solo Admin Global',
    builderCampaignWeightSub: 'Mayor peso = mayor prioridad cuando hay varias encuestas activas. Solo el Admin Global puede modificarlo.',
    builderWeightBase: 'Peso base (1–10)',
    builderWeightVeryLow: 'Muy Baja',
    builderWeightLow: 'Baja',
    builderWeightMedium: 'Media',
    builderWeightHigh: 'Alta',
    builderWeightVeryHigh: 'Muy Alta',
    builderBoostUrgent: 'Boost urgente',
    builderBoostUrgentSub: 'Eleva esta encuesta sobre todas las demás temporalmente',
    builderBoostDays: 'días',
    builderBoostActiveDays: 'día',
    builderBoostActiveMsg: 'Boost activo — esta encuesta tendrá máxima prioridad durante',
    builderNoBoostMsg: 'Sin boost activo — prioridad según peso base',
    builderParticipantsTitle: 'Participantes a evaluar',
    builderParticipantsSub: 'Define cuántas personas se evalúan por encuesta. Mínimo para anonimato y máximo para no saturar.',
    builderMinParticipantsLabel: 'Mínimo de participantes',
    builderMinParticipantsHint: 'Mín. para garantizar anonimato',
    builderMaxParticipantsLabel: 'Máximo de participantes',
    builderMaxParticipantsHint: 'Máx. personas a evaluar por encuesta',
    builderPrivacyTitle: 'Privacidad y anonimato',
    builderPrivacySub: 'Define si las retroalimentaciones se asociarán a la identidad del respondente.',
    builderEnableAnonymity: 'Activar anonimato',
    builderAnonymityDesc: 'Las retroalimentaciones no llevarán nombre de usuario — solo respuesta y hora',
    builderTranslationsTitle: 'Traducciones',
    builderTranslationsEuropeSub: 'Audiencia Europa — se requieren los 6 idiomas. Usa el toggle para activar o desactivar un idioma.',
    builderTranslationsSub: 'Se requiere traducción al Inglés como mínimo. Usa el toggle para activar idiomas adicionales.',
    builderAutoTranslateNote: 'Las traducciones se generan automáticamente con Azure Translator. Revisa y ajusta cada campo según sea necesario.',
    builderLangNotApplicable: 'No aplica',
    builderLangComplete: 'Listo',
    builderLangPending: 'Pendiente',
    builderLangRequired: 'Requerido',
    builderAutoTranslateBtn: 'Traducir auto.',
    builderLangApplies: 'Aplica',
    builderLangDoesNotApply: 'No aplica',
    builderTrlName: 'Nombre:',
    builderTrlDesc: 'Descripción:',
    builderTrlEmpty: 'vacío',
    builderLangDisabled: 'Esta lengua está desactivada para esta encuesta.',
    builderReviewTitle: 'Revisar y publicar',
    builderReviewTemplateTitle: 'Revisar template',
    builderEuropaPublishNote: 'Modo Europa: campaña independiente por GDPR. Recuerda contar con autorización de la OU Europa.',
    builderPublishIdLabel: 'Identificador',
    builderPublishInternal: '(interno)',
    builderPublishTypeLabel: 'Tipo',
    builderPublishAudienceLabel: 'Audiencia',
    builderPublishQuestionsLabel: 'Preguntas',
    builderPublishActiveDaysLabel: 'Días activos',
    builderPublishExpirationLabel: 'Expiración',
    builderPublishAnonymityLabel: 'Anonimato',
    builderPublishAnonymousVal: 'Anónima',
    builderPublishNominalVal: 'Nominal',
    builderCompleteBeforePublish: 'Completa antes de publicar:',
    builderCompleteBeforeSave: 'Completa antes de guardar:',
    builderReadyToPublish: 'Todo listo. Haz clic en Publicar Encuesta para activarla.',
    builderReadyToSaveTemplate: 'Todo listo. Haz clic en Guardar Template para guardarlo.',
    builderIconCatalogTitle: 'Catálogo de íconos',
    builderSystemIcons: 'Iconos del sistema',
    builderNoIcon: 'Sin ícono',
    builderMyCatalog: 'Mi catálogo',
    builderDeleteFromCatalog: 'Eliminar del catálogo',
    builderCatalogEmpty: 'Tu catálogo está vacío — sube un ícono y guárdalo aquí',
    builderUploadIcon: 'Subir nuevo ícono',
    builderIconNamePlaceholder: 'Nombre del ícono (ej. Innovación)',
    builderSelectFile: 'Seleccionar archivo',
    builderInvalidFormat: 'Formato no válido. Usa SVG o PNG con fondo transparente.',
    builderFileTooLarge: 'Archivo muy grande. Máximo 200 KB.',
    builderCustomIcon: 'Ícono personalizado',
    builderSaveForReuse: 'Guardar en catálogo para reutilizar',
    builderUseIcon: 'Usar ícono',
    builderIconHelp: 'SVG o PNG, fondo transparente, 512×512 px recomendado, máx. 200 KB',
    builderPreviewCompleteStep1: 'Completa los datos del Paso 1 para ver la vista previa',
    builderPreviewClickToEdit: 'Haz clic en cualquier texto para editar',
    builderPreviewNoQuestions: 'Las preguntas aparecerán aquí en el Paso 3',
    builderPreviewGeneral: 'General',
    builderPreviewPersonalized: 'Personalizada',
    builderPreviewPulsoEspecifica: 'Pulso Específica',
    builderPreviewChangeIcon: 'Cambiar ícono',
    builderPreviewIndividual: 'Individual',
    builderPreviewCollective: 'Colectivo',
    builderPreviewModeIndividual: 'Individual',
    builderPreviewModeMatrix: 'Matriz General',
    builderPreviewMissingTranslation: '(sin traducción)',
    builderPreviewWriteAnswer: 'Escribe tu respuesta aquí...',
    builderPreviewNoObs: 'No Observable',
    builderPreviewNA: 'N/A',
    // Step nav labels
    builderNavInfo: 'Info',
    builderNavAudiencia: 'Audiencia',
    builderNavPreguntas: 'Preguntas',
    builderNavConfig: 'Configuración',
    builderNavPublicar: 'Publicar',
    builderNavGuardar: 'Guardar',
    // Step 1 title
    builderInfoTitle: 'Información básica',
    // Audience step
    builderSelectAll: 'Seleccionar todo',
    // Language names
    langEn: 'Inglés',
    langDe: 'Alemán',
    langPt: 'Portugués',
    langFr: 'Francés',
    langNl: 'Holandés',
    langRo: 'Rumano',
    // Translation placeholders
    builderTrlPlaceholderIn: 'en',
    builderTrlPlaceholderOpt: 'Opción',
    builderTrlNoText: 'Sin texto aún',
    // New keys added during refactor
    builderLinkedTo: 'Vinculado a',
    builderSelectedIcon: 'Seleccionado',
    builderHidePreview: 'Ocultar vista previa',
    builderShowPreview: 'Mostrar vista previa',
    builderPreviewMorePersons: 'personas más',
    builderPreviewOption1: 'Opción 1',
    builderPreviewOption2: 'Opción 2',
    builderPreviewViewIn: 'Ver en:',
    builderFromOU: 'de',
    builderWillReceiveSurvey: 'recibirán esta encuesta',
    builderPersonsCount: 'personas',
    builderPersonsPlural: 'personas',
    builderPersonSingular: 'persona',
    builderInternalIdPlaceholder: 'Ej: Fundamentales Q1 2026',
    builderMeetingIdPlaceholder: 'Ej: 19:meeting_abc123@thread.v2',
    builderOptionDefault: 'Opción',
    builderRemovePerson: 'Quitar',
    builderSaveTemplateMock: 'Guardado como template ✓',
    builderPublishGlobalLabel: 'Global (excl. Europa)',
    builderTypeRating: 'Evaluación (1-4)',
    builderTypeMultiple: 'Opción Múltiple',
    builderTypeOpen: 'Pregunta Abierta',
    builderTypeBehaviors: 'Comportamientos',
    builderTypeNPS: 'NPS (1-10)',
    // System tab
    systemTab: 'Sistema',
    // Monitor tab
    monitorTab: 'Monitoreo',
    // Jobs tab
    jobsTab: 'Jobs',
  },
  jobs: {
    title: 'Jobs de Sincronización AD',
    subtitle: 'Estado, historial y ejecución manual de los jobs que sincronizan OUs y usuarios desde Azure AD.',
    ouCatalogSync: 'Sincronización de OUs',
    userCatalogSync: 'Sincronización de Usuarios',
    statusNeverRun: 'Nunca ejecutado',
    statusRunning: 'Corriendo…',
    statusSuccess: 'Éxito',
    statusSkipped: 'Saltado',
    statusFailed: 'Error',
    lastRun: 'Última corrida',
    duration: 'Duración',
    triggerScheduled: 'Automático',
    triggerManual: 'Manual',
    created: 'Creados',
    updated: 'Actualizados',
    unchanged: 'Sin cambios',
    skipReason: 'Motivo',
    errorMessage: 'Error',
    nextScheduled: 'Próxima ejecución automática',
    nextScheduledUnknown: 'Se calculará tras la primera corrida',
    runNow: 'Ejecutar ahora',
    runningDisabled: 'Ya está corriendo',
    viewHistory: 'Ver historial',
    hideHistory: 'Ocultar historial',
    historyEmpty: 'Todavía no hay corridas registradas.',
    historyLoading: 'Cargando historial…',
    historyError: 'No se pudo cargar el historial.',
    colDate: 'Fecha',
    colTrigger: 'Disparo',
    colStatus: 'Estado',
    colDuration: 'Duración',
    colDetail: 'Detalle',
    triggerError: 'No se pudo ejecutar el job.',
    triggerConflict: 'El job ya está corriendo — espera a que termine.',
  },
  monitor: {
    title: 'Monitoreo de Pipeline',
    subtitle: 'Auditoría de elegibilidad por reunión: reglas evaluadas, participantes excluidos y muestreo aplicado.',
    refresh: 'Actualizar',
    loading: 'Cargando eventos…',
    lastFetch: 'Actualizado',
    timeout: 'Timeout (10s) — MeetingService no respondió.',
    unknownError: 'Error desconocido',
    empty: 'Sin eventos de pipeline. Procesa o simula una reunión para ver los registros.',
    eligible: 'Elegible',
    ineligible: 'No elegible',
    excluded: 'Excluido',
    sampled: 'Muestreado',
    samplingApplied: 'Muestreo aplicado',
    noParticipants: 'Sin detalle de participantes.',
    statTotal: 'Reuniones procesadas',
    statEligible: 'Reuniones elegibles',
    statAvgSampled: 'Promedio muestreados',
    statAvgSampledSub: 'por reunión elegible',
    statSampling: 'Muestreo aplicado',
    statSamplingSub: 'reuniones con maxPax activo',
    colMeetingId: 'Reunión ID',
    colDate: 'Fecha',
    colDuration: 'Duración',
    colEvaluated: 'Evaluados',
    colEligible: 'Elegibles',
    colSampled: 'Muestreados',
    colMaxPax: 'Muestreo',
    colResult: 'Resultado',
    colUserId: 'Usuario',
    colOu: 'OU',
    colTimezone: 'Timezone',
    colToday: 'Hoy',
    colWeek: 'Semana',
    colInterval: 'Intervalo',
    colStatus: 'Estado',
    colReason: 'Razón',
    colSample: 'Encuesta',
    instancesTitle: 'Encuestas asignadas',
    instancesBtnTitle: 'Ver encuestas de este participante',
    instancesLoading: 'Cargando encuestas…',
    instancesEmpty: 'Sin instancias de encuesta para este participante en esta reunión.',
    instancesSurvey: 'Encuesta',
    instancesStatus: 'Estado',
    instancesExpires: 'Expira',
    instancesDownload: 'Descargar JSON',
    instancesClose: 'Cerrar',
    sortAsc: 'Ordenar ascendente',
    sortDesc: 'Ordenar descendente',
    recalculate: 'Recalcular respuestas',
    recalculateTitle: 'Recalcular conteo de respuestas en todas las encuestas',
    recalculateSuccess: 'Recálculo completado: {{count}} encuesta(s) actualizadas.',
    recalculateError: 'Error al recalcular respuestas.',
    cacheTitle: 'Caché del catálogo de OUs',
    cacheLoading: 'Consultando caché…',
    cacheError: 'No se pudo obtener el estado de la caché de OUs.',
    cachePopulated: 'Poblada',
    cacheNotPopulated: 'No poblada',
    cacheOuCount: 'OUs en caché',
    cacheLastSynced: 'Última sincronización',
    cacheNeverSynced: 'Nunca sincronizado',
  },
  system: {
    title: 'Diagnóstico del Sistema',
    subtitle: 'Estado en tiempo real de todos los microservicios y workers del backend.',
    refreshAll: 'Actualizar todo',
    refresh: 'Actualizar',
    lastChecked: 'Última verificación',
    checking: 'Verificando…',
    never: 'Nunca',
    statusHealthy: 'Saludable',
    statusDegraded: 'Degradado',
    statusError: 'Error de conexión',
    showDetails: 'Ver checks',
    hideDetails: 'Ocultar checks',
    legendTitle: 'Glosario de estados',
    legendHealthyDesc: 'Todos los checks internos del servicio respondieron correctamente.',
    legendDegradedDesc: 'El servicio responde pero MongoDB, Redis o Service Bus reportaron error.',
    legendErrorDesc: 'No se pudo alcanzar el servicio desde el frontend (timeout, CORS o servicio caído).',
    checkMongodb: 'MongoDB',
    checkRedis: 'Redis',
    checkServiceBus: 'Service Bus',
    checkSubscriptions: 'Suscripciones',
    activeMessages: 'Mensajes activos',
    deadLetterMessages: 'Dead Letter',
    environment: 'Entorno',
    version: 'Versión',
    workers: 'Workers',
    workersDesc: 'Estado inferido desde las suscripciones de Service Bus.',
    analyticsWorker: 'Analytics Worker',
    expirationWorker: 'Expiration Worker',
    noStats: 'Sin estadísticas de suscripción disponibles.',
    namespace: 'Namespace',
    topic: 'Topic',
    ok: 'OK',
    error: 'Error',
  },
  analytics: {
    title: 'Dashboard Ejecutivo',
    subtitle: 'Sigma Pulse Analytics',
    bias: 'Sesgos',
    omissions: 'Omisiones',
    personal: 'Personal',
    score: 'Score',
    responses: 'Respuestas',
    participants: 'Participantes',
    period: 'Período',
    ou: 'Unidad Organizacional',
    noData: 'Sin datos suficientes',
    completionRate: 'Completitud',
    avgByCategory: 'Promedio por categoría',
    organization: 'Organización',
    fundamentalsRadar: 'Radar de fundamentales',
    heatmapPersonFund: 'Mapa de calor — Score por persona y fundamental',
    moduleInDev: 'Módulo en desarrollo',
    executiveSubtitle: 'vista ejecutiva',
    exec: {
      ouTech: 'Tecnología',
      ouOps: 'Operaciones',
      ouSales: 'Ventas',
    },
    tabs: {
      summary: 'Resumen',
      fundamentals: 'Fundamentales',
      heatmap: 'Mapa de Calor',
      orgNetwork: 'Red Organizacional',
      generational: 'Generacional',
    },
    filterBar: {
      allOrg: 'Toda la organización',
      allBU: 'Todas las BUs',
      allDept: 'Todos los Depts',
      allFund: 'Todos los fundamentales',
      clearFilters: 'Limpiar filtros',
      dateFrom: 'Desde',
      dateTo: 'Hasta',
    },
    kpi: {
      evaluations: 'Evaluaciones',
      avgScore: 'Score Promedio',
      responseRate: 'Tasa Respuesta',
      avgPerDay: 'Promedio / Día',
      evaluators: 'Evaluadores',
      scale: 'escala 1–4',
      noObservables: 'no observables',
      perDay: 'encuestas por día',
      activeParticipants: 'participantes activos',
      ofTotal: 'totales',
    },
    summary: {
      topBehaviors: 'Top Daily Habits',
      topDailyHabitsSubtitle: 'Hábitos con mayor impacto en cultura',
      oppSubtitle: 'Hábitos con mayor área de mejora',
      opportunities: 'Áreas de Oportunidad',
      omissionsByUnit: 'Omisiones por Unidad',
      omissionsSubtitle: 'Tasa de omisión por OU y BU — ordenadas de mayor a menor · Haz clic en una OU para ver sus BUs',
      downloadExcel: 'Descargar Excel',
      omitType: 'Tipo',
      omitPeople: 'Personas',
      omitRate: 'Tasa Omisión',
      noOmissions: 'Sin omisiones significativas',
      percentileDistribution: 'Distribución por Percentil',
      percentileSubtitle: 'Qué porcentaje de la población cae en cada rango de score',
      personsEvaluated: 'personas evaluadas',
      excellent: 'Excelente',
      good: 'Bueno',
      developing: 'En desarrollo',
      attention: 'Atención',
      fundPositioning: 'Posicionamiento Fundamentales',
      fundPositioningDesc: 'Ranking, mayor/menor puntaje y tasa de no observable por fundamental',
      highestScore: 'Mayor puntaje',
      lowestScore: 'Menor puntaje',
      mostNoObs: 'Mayor No Observable',
      scoreByOU: 'Score por Unidad Organizacional',
      scoreByOUSubtitle: 'Haz clic en una OU para ver el desglose por BU y Departamento',
      person: 'persona',
      persons: 'personas',
    },
    fundamentals: {
      title: 'Score por Fundamental',
      subtitle: 'Expande cada fundamental para ver sus daily habits y desglose por OU',
      evalLabel: 'eval',
      confPreliminary: 'Dato preliminar',
      confBasedOn: 'Basado en {{n}} eval',
    },
    heatmap: {
      title: 'Mapa de Calor Cultural',
      subtitle: 'Toca cualquier fila para explorar sus sub-unidades',
      unit: 'Unidad',
      unitOU: 'Unidad Organizacional',
      unitBU: 'Business Unit',
      unitDept: 'Departamento',
      unitPerson: 'Responsable',
      allOrg: 'Toda la organización',
      hint: 'Toca cualquier fila para explorar el nivel siguiente →',
      person: 'persona',
      persons: 'personas',
      legendCritical: 'Crítico',
      legendLow: 'Bajo',
      legendMedium: 'Medio',
      legendGood: 'Bueno',
      legendExcellent: 'Excelente',
      noOu: 'Sin OU',
    },
    ona: {
      title: 'Red Organizacional (ONA)',
      subtitle: 'Árbol interactivo de unidades organizacionales (OU)',
      treeHint: 'Expande cada nodo para navegar los niveles de OU de la organización.',
      omissions: 'Omisiones',
      totalPeople: 'Personas',
      avgScore: 'Score promedio',
      totalEvals: 'Total evaluaciones',
      collaboratorsKpi: 'Colaboradores',
      highestOmission: 'Mayor omisión',
      omissionsRanking: 'Ranking de omisiones',
      maturityCulture: 'Madurez cultural',
      maturityLegend: 'Leyenda de madurez',
      maturityInitial: 'Inicial',
      maturityGrowing: 'En desarrollo',
      maturityConsolidated: 'Consolidado',
      maturityRoleModel: 'Role Model',
      evalsLabel: 'evaluaciones',
      noEvals: 'Sin evaluaciones',
      collaboratorsLabel: 'colaboradores',
      omissionLabel: 'omisión',
      evalsShort: 'evals',
    },
    gen: {
      panorama: 'Panorama',
      ranking: 'Ranking',
      brechas: 'Brechas',
      avgAge: 'Edad promedio',
      title: 'Análisis Generacional',
      subtitle: 'Distribución y madurez cultural por cohorte · {{n}} personas mapeadas',
      noRepresentation: 'Sin representación',
      scoreLabel: 'Score',
      omissionLabel: 'Omisión',
      personas: 'personas',
      age: 'Edad',
      all: 'Todos',
      noData: 'Sin datos para este filtro',
      fundamental: 'Fundamental',
      gapCol: 'Δ Brecha',
      brechaNote: 'Brecha mayor: {{fund}} · Δ {{delta}} pts entre generaciones',
      brechaSource: 'Diferencia vs. el promedio general del fundamental en la organización',
      responseCount: '{{n}} respuestas',
    },
  },
  userConfig: {
    fabTitle: 'Configurar perfil de usuario',
    title: 'Perfil de usuario (demo)',
    subtitle: 'Modo pruebas — simula los datos que se recibirán de Teams SSO al integrar con el back-end',
    nombre: 'Nombre',
    correo: 'Correo electrónico',
    ou: 'OU (Unidad Organizacional)',
    do_: 'DO (Dirección / División)',
    bu: 'BU (Unidad de Negocio)',
    departamento: 'Departamento',
    puesto: 'Puesto',
    numeronomina: 'Número de nómina',
    role: 'Rol',
    roleDetected: 'Rol detectado',
    roleNotFound: 'Correo no encontrado en usuarios — se usará Empleado',
    save: 'Guardar perfil',
    namePlaceholder: 'Ej: Ana García',
    emailPlaceholder: 'Ej: agarcia@sigma.com',
    ouPlaceholder: 'Ej: Tecnología',
    doPlaceholder: 'Ej: Dirección de Tecnología',
    buPlaceholder: 'Ej: México',
    deptPlaceholder: 'Ej: Desarrollo de Software',
    puestoPlaceholder: 'Ej: Ingeniero de Software Sr.',
    nominaPlaceholder: 'Ej: 123456',
    fechaNacimiento: 'Fecha de nacimiento',
    tenant: 'Tenant',
  },
  errors: {
    generic: 'Ocurrió un error inesperado',
    unauthorized: 'No tienes permisos para esta acción',
    notFound: 'Recurso no encontrado',
    network: 'Error de conexión. Verifica tu red.',
  },
};

export default es;

